module.exports = __webpack_public_path__ + "components/patterns/locationRoomList/location-room-list.tpl.php";